/**
 * Servicio para obtener constantes dinámicas desde el backend
 * Reemplaza las constantes hardcodeadas en el frontend
 * Utiliza apiService para mantener consistencia en peticiones
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { constantsApi } from '@/utils/apiService';
// Cache para las constantes
var constantsCache = new Map();
var CACHE_TTL = 1000 * 60 * 30; // 30 minutos
var ConstantsService = /** @class */ (function () {
    function ConstantsService() {
    }
    ConstantsService.prototype.fetchWithCache = function (fetcher, cacheKey) {
        return __awaiter(this, void 0, void 0, function () {
            var cached, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cached = constantsCache.get(cacheKey);
                        if (cached && (Date.now() - cached.timestamp) < CACHE_TTL) {
                            return [2 /*return*/, cached.data];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetcher()];
                    case 2:
                        data = _a.sent();
                        // Guardar en cache
                        constantsCache.set(cacheKey, {
                            data: data,
                            timestamp: Date.now(),
                        });
                        return [2 /*return*/, data];
                    case 3:
                        error_1 = _a.sent();
                        console.error("[ConstantsService] Error fetching ".concat(cacheKey, ":"), error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Obtener constantes para formularios de propiedades
     */
    ConstantsService.prototype.getPropertyConstants = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchWithCache(function () { return constantsApi.getPropertyConstants(); }, 'property-constants')];
            });
        });
    };
    /**
     * Obtener constantes para formularios de room types
     */
    ConstantsService.prototype.getRoomTypeConstants = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchWithCache(function () { return constantsApi.getRoomTypeConstants(); }, 'room-type-constants')];
            });
        });
    };
    /**
     * Obtener constantes para formularios de rate plans
     */
    ConstantsService.prototype.getRatePlanConstants = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchWithCache(function () { return constantsApi.getRatePlanConstants(); }, 'rate-plan-constants')];
            });
        });
    };
    /**
     * Obtener constantes generales del sistema
     */
    ConstantsService.prototype.getGeneralConstants = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchWithCache(function () { return constantsApi.getGeneralConstants(); }, 'general-constants')];
            });
        });
    };
    /**
     * Obtener sugerencias de timezone por país
     */
    ConstantsService.prototype.getTimezoneSuggestions = function (countryCode) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey;
            return __generator(this, function (_a) {
                cacheKey = "timezone-suggestions-".concat(countryCode);
                return [2 /*return*/, this.fetchWithCache(function () { return constantsApi.getTimezoneSuggestions(countryCode); }, cacheKey)];
            });
        });
    };
    /**
     * Obtener sugerencias de currency por país
     */
    ConstantsService.prototype.getCurrencySuggestions = function (countryCode) {
        return __awaiter(this, void 0, void 0, function () {
            var cacheKey;
            return __generator(this, function (_a) {
                cacheKey = "currency-suggestions-".concat(countryCode);
                return [2 /*return*/, this.fetchWithCache(function () { return constantsApi.getCurrencySuggestions(countryCode); }, cacheKey)];
            });
        });
    };
    /**
     * Obtener constantes para formularios de cancellation policies
     */
    ConstantsService.prototype.getCancellationPolicyConstants = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchWithCache(function () { return constantsApi.getCancellationPolicyConstants(); }, 'cancellation-policy-constants')];
            });
        });
    };
    /**
     * Obtener constantes para formularios de tax
     */
    ConstantsService.prototype.getTaxConstants = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchWithCache(function () { return constantsApi.getTaxConstants(); }, 'tax-constants')];
            });
        });
    };
    /**
     * Obtener lista de países
     */
    ConstantsService.prototype.getCountriesConstants = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchWithCache(function () { return constantsApi.getCountriesConstants(); }, 'countries-constants')];
            });
        });
    };
    /**
     * Obtener constantes extendidas para formularios de rate plans
     */
    ConstantsService.prototype.getRatePlanExtendedConstants = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchWithCache(function () { return constantsApi.getRatePlanExtendedConstants(); }, 'rate-plan-extended-constants')];
            });
        });
    };
    /**
     * Obtener constantes para formularios de hotel policies
     */
    ConstantsService.prototype.getHotelPolicyConstants = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchWithCache(function () { return constantsApi.getHotelPolicyConstants(); }, 'hotel-policy-constants')];
            });
        });
    };
    /**
     * Limpiar cache de constantes
     */
    ConstantsService.prototype.clearCache = function () {
        constantsCache.clear();
    };
    /**
     * Limpiar cache específico
     */
    ConstantsService.prototype.clearCacheKey = function (key) {
        constantsCache.delete(key);
    };
    return ConstantsService;
}());
// Instancia singleton
export var constantsService = new ConstantsService();
// Hook personalizado para React Query
export var CONSTANTS_QUERY_KEYS = {
    property: 'property-constants',
    roomType: 'room-type-constants',
    ratePlan: 'rate-plan-constants',
    general: 'general-constants',
    cancellationPolicy: 'cancellation-policy-constants',
    tax: 'tax-constants',
    countries: 'countries-constants',
    ratePlanExtended: 'rate-plan-extended-constants',
    hotelPolicy: 'hotel-policy-constants',
    timezoneSuggestions: function (countryCode) { return ['timezone-suggestions', countryCode]; },
    currencySuggestions: function (countryCode) { return ['currency-suggestions', countryCode]; },
};
// Helpers para usar con React Query
export var constantsQueries = {
    property: function () { return ({
        queryKey: [CONSTANTS_QUERY_KEYS.property],
        queryFn: function () { return constantsService.getPropertyConstants(); },
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL * 2,
    }); },
    roomType: function () { return ({
        queryKey: [CONSTANTS_QUERY_KEYS.roomType],
        queryFn: function () { return constantsService.getRoomTypeConstants(); },
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL * 2,
    }); },
    ratePlan: function () { return ({
        queryKey: [CONSTANTS_QUERY_KEYS.ratePlan],
        queryFn: function () { return constantsService.getRatePlanConstants(); },
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL * 2,
    }); },
    general: function () { return ({
        queryKey: [CONSTANTS_QUERY_KEYS.general],
        queryFn: function () { return constantsService.getGeneralConstants(); },
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL * 2,
    }); },
    timezoneSuggestions: function (countryCode) { return ({
        queryKey: CONSTANTS_QUERY_KEYS.timezoneSuggestions(countryCode),
        queryFn: function () { return constantsService.getTimezoneSuggestions(countryCode); },
        enabled: !!countryCode && countryCode.length === 2,
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL * 2,
    }); },
    currencySuggestions: function (countryCode) { return ({
        queryKey: CONSTANTS_QUERY_KEYS.currencySuggestions(countryCode),
        queryFn: function () { return constantsService.getCurrencySuggestions(countryCode); },
        enabled: !!countryCode && countryCode.length === 2,
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL * 2,
    }); },
    cancellationPolicy: function () { return ({
        queryKey: [CONSTANTS_QUERY_KEYS.cancellationPolicy],
        queryFn: function () { return constantsService.getCancellationPolicyConstants(); },
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL * 2,
    }); },
    tax: function () { return ({
        queryKey: [CONSTANTS_QUERY_KEYS.tax],
        queryFn: function () { return constantsService.getTaxConstants(); },
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL * 2,
    }); },
    countries: function () { return ({
        queryKey: [CONSTANTS_QUERY_KEYS.countries],
        queryFn: function () { return constantsService.getCountriesConstants(); },
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL * 2,
    }); },
    ratePlanExtended: function () { return ({
        queryKey: [CONSTANTS_QUERY_KEYS.ratePlanExtended],
        queryFn: function () { return constantsService.getRatePlanExtendedConstants(); },
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL * 2,
    }); },
    hotelPolicy: function () { return ({
        queryKey: [CONSTANTS_QUERY_KEYS.hotelPolicy],
        queryFn: function () { return constantsService.getHotelPolicyConstants(); },
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL * 2,
    }); },
};
